import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

export const useRejectCompany = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['rejectCompany']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.rejectCompany,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      options?.onSuccess?.(...args)
    },
  })
}
